import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'empty',
  standalone: true
})
export class EmptyPipe implements PipeTransform {

  public transform(val: string | number): string | number {
    return val || '—';
  }
}
